import { render, staticRenderFns } from "./SetariFurnizori.vue?vue&type=template&id=23b49f74&scoped=true"
import script from "./SetariFurnizori.vue?vue&type=script&lang=js"
export * from "./SetariFurnizori.vue?vue&type=script&lang=js"
import style0 from "./SetariFurnizori.vue?vue&type=style&index=0&id=23b49f74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b49f74",
  null
  
)

export default component.exports